import { get, post, del } from "../../helpers/api_helper"

// Voucher Types (catalog + numbering config) — Administration > Settings > Voucher Types
export const searchVoucherTypes = params => get(`voucher-types?${params || ""}`)
export const getVoucherType = id => get(`voucher-types/${id}`)
export const createVoucherType = data => post("voucher-types", data)
export const updateVoucherType = (id, data) => post(`voucher-types/${id}`, data)
export const deleteVoucherType = id => del(`voucher-types/${id}`)
